export const APP_NAME = 'uPulse Web App';

export const LOCATION_PROTOCOL = window.location.protocol;
export const LOCATION_HOSTNAME = window.location.hostname;
export const LOCATION_PORT = window.location.port;

export const PORT = '9000';
export const SERVICE_PORT = '9002';

export const IS_DEV_MODE = process.env.NODE_ENV === 'development';

export const HOST = IS_DEV_MODE ? `localhost:9000` : `${window.location.host}`;
export const URL_HOST = `${LOCATION_PROTOCOL}//${LOCATION_HOSTNAME}:${LOCATION_PORT}`;

export const SERVICE_URL_HOST = `${LOCATION_PROTOCOL}//${LOCATION_HOSTNAME}:${SERVICE_PORT}`;

export const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';

export const DEVELOPMENT_MODE_PREFIX = 'dev';

export const REGEX_NUMERICAL_VALIDATION = /^[-]?(?!0{2,})(?!\.$)[0-9]*\.?(?:[0-9]+)?$/;
export const REGEX_POSITIVE_INT_VALIDATION = /^[+]?(?!0{2,})\d+$/;
export const REGEX_FILE_EXTENSION = /[0-9a-z]+$/i;
export const REGEX_CONICAL_50 = /50\s?mL/i;
export const REGEX_CONICAL_15 = /15\s?mL/i;

export const DEFAULT_SOFTWARE_VERSION = '0.0.0.0';

export const TOAST_TIMEOUT = 3000;

export const GRID_LABEL = {sm: 150, md: 150, lg: 150};
export const GRID_VALUE = {sm: 200, md: 200, lg: 200};

export const DEV_MODE_LOG_CONFIG = {
  port: '5005',
  ipServer: 'http://localhost',
  logConfig: {
    browserLogLevel: 0,
    logLevel: 2,
    logMaxStackSize: 200,
    logKey: 'ui_log',
  },
};

export const VERSION_2 = 'V2';
export const SYSTEM_UPDATE_FILE = 'PC.Server.latest.tar.gz';
export const VERSION_3 = 'V3';

export const TIME_OUT_REFRESH = 3000;
